import styles from './PatternCard.module.css'
import arrow from './assets/arrow.svg';

const PatternCard = ({ pattern, onSelect }) => {
    const patternName = pattern.name || pattern.patternName || '';
    const patternId = pattern.id || pattern.patternId || '';
    const thumb = `patterns/${patternName}_roomview.jpg`;
    const thumbBlank = `patterns/${patternName}.jpg`;
    

    return (
        <div className={styles.content} onClick={() => {onSelect(pattern.name)}}>
            <div className={styles.patternContainer}>
                <div className={styles.patternImage}>
                    <img 
                        src={thumb}
                        alt={patternName}
                        className={styles.defaultThumb}
                    />
                    <img 
                        src={thumbBlank}
                        alt={`${patternName} blank`}
                        className={styles.hoverThumb}
                    />
                </div>
                <div className={styles.description}>
                    <p className={styles.title}>{patternName}</p>
                      <img src={arrow} alt='arrow' />
                </div>
            </div>
        </div>
    );
};

export default PatternCard;
